"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./index.scss");
const Button_1 = require("@Components/Buttons/Button");
const navigation_1 = __importDefault(require("@App/navigation"));
const react_router_dom_1 = require("react-router-dom");
const Popup_1 = __importDefault(require("@Components/Popups/Popup"));
const SelfPublisherSongwriterPopup = (props) => {
    const { onClose } = props;
    const navigate = (0, react_router_dom_1.useNavigate)();
    const startRegistration = () => __awaiter(void 0, void 0, void 0, function* () {
        onClose();
        navigate(navigation_1.default.registrationRightsholder.form(), { state: { memberType: 'Songwriter' } });
    });
    return (react_1.default.createElement(Popup_1.default, { onClose: () => onClose(), showClose: true, className: 'self-publisher-songwriter' },
        react_1.default.createElement("div", null,
            react_1.default.createElement("h3", null, "You selected: Self-published or Partially Self-Published"),
            react_1.default.createElement("p", null, "Since you are self-published or partially self-published, the Member Hub ensures that your songs are properly registered and that you have access to tools for managing your own catalog and royalties. Let\u2019s continue and set up your Member Hub details first.")),
        react_1.default.createElement("div", { className: "footer-block" },
            react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'secondary', onClick: () => onClose() }, "Back"),
            react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'primary', onClick: () => startRegistration() }, "Next"))));
};
exports.default = SelfPublisherSongwriterPopup;
